import type { ReactNode } from 'react';

import { Sheet } from './Sheet';

interface StackedSheetProps {
  children: ReactNode;
  dataCy?: string;
}

export const StackedSheet = ({ children, dataCy }: StackedSheetProps) => {
  return (
    <div className="relative flex flex-col items-center" data-cy={dataCy}>
      <Sheet className="relative z-20 w-full lxl:!p-64">{children}</Sheet>
      <div className="z-10 w-full px-16">
        <div className="rounded-2 z-10 h-12 bg-paper-4 shadow-sheet-stacked lxl:h-20" />
      </div>
      <div className="w-full px-32">
        <div className="rounded-2 h-12 bg-paper-6 shadow-sheet-stacked lxl:h-20 dark:bg-paper-7" />
      </div>
    </div>
  );
};
